import { cn } from "@repo/lib";
import { type ReactNode, type ReactElement } from "react";

interface IconListRootProps {
  children: ReactElement<IconListItemProps>[];
  className?: string;
}

export const IconListRoot = ({ children, className }: IconListRootProps): JSX.Element => {
  return <div className={cn("flex flex-col gap-2", className)}>{children}</div>;
};

interface IconListItemProps {
  children: ReactNode;
  className?: string;
}

export const IconListItem = ({ children, className }: IconListItemProps): JSX.Element => {
  return <div className={cn("flex gap-1 items-center", className)}>{children}</div>;
};

export const IconListItemIcon = ({
  children,
  className,
}: {
  children: ReactNode;
  className?: string;
}): JSX.Element => {
  return <div className={cn("shrink-0 fill-secondary-500", className)}>{children}</div>;
};

export const IconListItemText = ({
  children,
  className,
}: {
  children: ReactNode;
  className?: string;
}): JSX.Element => {
  return <span className={cn("text-neutral-500 text-sm", className)}>{children}</span>;
};
